import React from 'react'
import { Warning as WarningIcon } from '@mui/icons-material'
import styled from '@emotion/styled'
import { FormControlLabel, Switch, Typography } from '@mui/material'

import { MUIRouterLink } from '@edge/spark/ui-mui'
import autoSuggestions from './autoSuggestions'
import isHelpString from './isHelpString'
import ItemArrayDisplay from './ItemArrayDisplay'

interface Props {
    searchString: string
}

const StyledHelpList = styled.div`
    padding: 0 8px;
    color: #666666;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.43;
    letter-spacing: 0.25px;
`

const QueryLanguageHelper = ({ searchString }: Props): JSX.Element => {
    const autoSuggestionsLower = React.useMemo(() => {
        return autoSuggestions.map(({ qualifiers, text }) => {
            return { qualifiers: qualifiers.map((item) => item.toLowerCase()), text }
        })
    }, [])
    const autoSuggestionsSorted = React.useMemo(() => {
        return [...autoSuggestionsLower].sort((a, b) => {
            return a.qualifiers[0].localeCompare(b.qualifiers[0], undefined, {
                sensitivity: 'base',
            })
        })
    }, [autoSuggestionsLower])
    const [sorted, setSorted] = React.useState<boolean>(false)
    const toggleSort = () => {
        setSorted(!sorted)
    }
    const displayList = sorted ? autoSuggestionsSorted : autoSuggestionsLower
    if (isHelpString(searchString)) {
        return (
            <StyledHelpList>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="body1">Examples:</Typography>
                    <FormControlLabel
                        control={<Switch checked={sorted} onChange={toggleSort} color="primary" />}
                        label="Sort A-Z"
                        style={{ padding: 0 }}
                    />
                </div>
                {displayList.map(({ text }) => {
                    return (
                        <div key={Math.random()}>
                            <ItemArrayDisplay items={text} />
                        </div>
                    )
                })}
            </StyledHelpList>
        )
    }
    const lastSearchTag = searchString.split(' ').pop()?.replace(':', '').toLowerCase() || ''
    const foundMatch = autoSuggestionsLower.find(({ qualifiers }) => qualifiers.includes(lastSearchTag))
    return (
        <StyledHelpList>
            {foundMatch?.text ? (
                <>
                    <div>Examples:</div>
                    <ItemArrayDisplay items={foundMatch.text} />
                </>
            ) : (
                <>
                    <div
                        style={{
                            fontWeight: 500,
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <WarningIcon color="secondary" />
                        <span>Invalid Auction Query Language</span>
                    </div>
                    <div>
                        <div>
                            Type <strong>?</strong> for examples.
                        </div>
                        <div>
                            Refer to the{' '}
                            <MUIRouterLink
                                href="https://support.auctionedge.com/support/solutions/articles/13000073439-spark-search"
                                color="primary"
                                underline="always"
                            >
                                support docs
                            </MUIRouterLink>{' '}
                            for help structuring AQL
                        </div>
                    </div>
                </>
            )}
        </StyledHelpList>
    )
}

export default QueryLanguageHelper
